import { AgChartOptions } from "@ag-grid-community/core";
import { ColumnKeyEnum } from "../../../constants";
import { IRegistryDataRow } from "../../../models/RegistryData";
import { IRegistryDataColumn } from "../../../models/RegistryDataColumn";

export const getAgeChartOptions = (
  rows: IRegistryDataRow[],
  colDef: IRegistryDataColumn
): AgChartOptions => {
  const ageData = getAgeChartData(rows, colDef);

  const chartOptions: AgChartOptions = {
    title: {
      text: "Age",
    },
    subtitle: {
      text: "Age is calculated from the date of birth",
    },
    background: {
      visible: false,
    },
    data: ageData,
    theme: {
      baseTheme: "ag-vivid",
      palette: {
        fills: ["#386968"],
        strokes: ["#1F5755"],
      },
    },
    series: [
      {
        type: "histogram",
        xKey: "age",
        xName: "Individual Age",
        shadow: {
          enabled: false,
        },
        highlightStyle: {
          item: {
            fill: "#386968",
            strokeWidth: 1,
          },
        },
      },
    ],
    legend: {
      enabled: false,
    },
    axes: [
      {
        type: "number",
        position: "bottom",
        title: { text: "Age band (years)" },
      },
      {
        type: "number",
        position: "left",
        title: { text: "Number of individuals" },
      },
    ],
  };

  return chartOptions;
};

export const getAgeChartData = (
  rows: IRegistryDataRow[],
  colDef: IRegistryDataColumn
) => {
  const chartData: any[] = [];

  rows.forEach((row) => {
    const lookupKey = ColumnKeyEnum.age;

    if (row && row.hasOwnProperty(lookupKey)) {
      let ageRaw = row[lookupKey];

      const ageNum = Number(ageRaw);

      // Make sure its a postive number and its not a 0 because of
      // blank conversion
      if (ageNum >= 0 && ageRaw) {
        chartData.push({ age: ageNum });
      }
    }
  });

  return chartData;
};
